import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("expoflo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem("expoflo_token", token);
  else localStorage.removeItem("expoflo_token");
}

export function getUser() {
  const raw = localStorage.getItem("expoflo_user");
  return raw ? JSON.parse(raw) : null;
}

export function setUser(user) {
  if (user) localStorage.setItem("expoflo_user", JSON.stringify(user));
  else localStorage.removeItem("expoflo_user");
}

export function logout() {
  setToken(null);
  setUser(null);
}

export function fileUrl(path) {
  if (!path) return null;
  return `${API}/files/${path}`;
}
